/** One cookie's raw value from a `Cookie` header or `document.cookie`, or
 *  undefined when absent. Pure, so the browser and the server read alike. */
export const cookieFromHeader = (cookieHeader: string, name: string): string | undefined =>
  cookieHeader
    .split(/;\s*/)
    .find((c) => c.startsWith(`${name}=`))
    ?.slice(name.length + 1);
